import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import { useRef, useState } from 'preact/hooks'
import TextareaAutosize from 'react-textarea-autosize'
import styles from './index.module.scss'

export const TextArea: FunctionalComponent<{
  minRows?: number
  view?: 'post' | 'default'
  disabled?: boolean
  placeholder?: string
  value?: string
  onChange?: (value: string) => void
}> = props => {
  const ref = useRef<HTMLTextAreaElement>(null)
  const [focus, setFocus] = useState(false)

  return (
    <div
      class={classNames(
        styles.root,
        styles[props.view ?? 'default'],
        {
          [styles.focus]: focus,
        },
      )}
    >
      <TextareaAutosize
        ref={ref}
        disabled={props.disabled}
        minRows={props.minRows ?? 2}
        class={styles.textarea}
        placeholder={props.placeholder}
        value={props.value ?? ''}
        onChange={e => {
          props.onChange?.(e.currentTarget.value)
        }}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
      />
    </div>
  )
}
